import { Divider, Skeleton } from 'antd';
import 'moment/locale/en-gb';
import { useNavigate, useParams } from 'react-router-dom';
import { useMydays } from '../../fetchHooks/useMydays';
import { useTabSync } from '../../hooks/useTabSync';
import { useEscapeKey } from './Files.tsx';
import type { MyDayVariantType } from './MyDayPage';
import MydayDetails from './MydayDetails';

interface ModalTitleProps {
  title: string;
}
export const ModalTitle = ({ title }: ModalTitleProps) => (
  <>
    <h1
      style={{
        textAlign: 'center',
        paddingBottom: '2rem',
        paddingTop: '2rem',
        background: 'rgba(147, 188, 255, 0.3)',
        borderRadius: 16,
      }}
    >
      {title}
    </h1>
    <Divider />
  </>
);

export const ShowExportOfAllDays = () => {
  const { tab } = useParams();
  const { data: mydaysResponse, isLoading: isLoadingMydays } = useMydays();
  // Handle both new paginated format { data: [], pagination: {} } and old array format []
  const mydays = Array.isArray(mydaysResponse) ? mydaysResponse : mydaysResponse?.data || [];
  const { activeKey } = useTabSync(tab as MyDayVariantType);
  const navigate = useNavigate();
  useEscapeKey(() => navigate(-1));
  if (!activeKey) {
    return null;
  }

  if (isLoadingMydays) {
    return <Skeleton.Input active size="default" style={{ width: 300 }} />;
  }
  return (
    <div style={{ backgroundColor: 'white', minWidth: '100vw', width: '100%' }}>
      <div style={{ maxWidth: '1600px', width: '100%', padding: '2rem' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#1890ff', fontSize: '28px', marginBottom: '10px' }}>LifeLog Export</h1>
          <p style={{ color: '#666', fontSize: '16px' }}>Complete diary export - {mydays?.length || 0} entries</p>
          <Divider />
        </div>
        {mydays
          ?.filter((myday) => myday.type === activeKey)
          ?.map((myday) => (
            <MydayDetails key={`export-${myday.id}`} mydayId={myday.id} isExport />
          ))}
      </div>
    </div>
  );
};
